import { useMemo } from "react";

import { imageToCanvas } from "../utils";

/**
 * Converts an HTMLImageElement to a HTMLCanvasElement.
 *
 * @param image The HTMLImageElement to convert.
 * @param enabled Whether the hook should perform the conversion.
 *   If `false`, the hook will always return `undefined`.
 * @returns A HTMLCanvasElement or undefined if the image is not valid.
 */
export function useCanvasImage(image?: HTMLImageElement, enabled = true): HTMLCanvasElement | undefined {
  const canvasImage = useMemo(
    () => (enabled && image && image.naturalWidth > 0 && image.naturalHeight > 0 ? imageToCanvas(image) : undefined),
    [image, enabled]
  );

  return canvasImage;
}
